<template>
  <div class="Liuhe-list-page">

    <div class="head_area">
      <div class="leftImg">
        <img @click="back" src="/static/image/icon-jiantou@2x.eb0b501e01e95b720b727b63a23960e3.png" class="top_back">
      </div>
      <span class="head_text">{{ $t('MI28') }}</span>
      <span class="right_menu"></span>
    </div>
    <div class="content">
      <div class="list">
        <div class="list-item-bg">
          <div class="list-item" style="background-image: url('/static/image/new/Liuhe/list-item-bg2.png')"  @click="jumpPage('/game-room', 'one')">
            <div class="title">{{ $t('初级') }}</div>
            <div>
              <div class="desc">229{{ $t('在线') }}</div>
            </div>
<!--            <img src="/static/image/new/Liuhe/list-icon1.png" alt="" class="bg-img">-->
          </div>
        </div>
        <div class="list-item-bg">
          <div class="list-item" style="background-image: url('/static/image/new/Liuhe/list-item-bg3.png')"  @click="jumpPage('/game-room', 'two')">
            <div class="title">{{ $t('中级') }}</div>
            <div>
              <div class="desc">25{{ $t('在线') }}</div>
            </div>
<!--            <img src="/static/image/new/Liuhe/list-icon1.png" alt="" class="bg-img">-->
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LiuheList',
  data() {
    return {

    }
  },
  methods: {
    back() {
      window.history.go(-1)
    },
    jumpPage(path, room) {
      this.$router.push({
        path: path,
        query: {
          room: room,
          game_video: 'jld28',
          name: this.name
        }
      });
    }
  }
}
</script>


<style scoped lang="scss">
.Liuhe-list-page {
  background-color: #000;
  //background-image: url("/static/image/new/game/game-room-bg.png");
  //background-size: 100% 100%;
  //position: fixed;
  //top: 0;
  //left: 0;
  width: 100%;
  height: 100%;
  margin: auto;
  z-index: 1;
  overflow: hidden;
  bottom: 0;
  display: flex;
  flex-direction: column;
  color: #fff;
  .head_area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;
    .leftImg {
      flex: 1;
      text-align: right;
      transform: rotate(180deg);
    }
    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }
    .head_text {
      font-size: 0.438rem;
      font-weight: bold;
      font-family: PingFang SC;
      color: #fff;
      width: 80%;
      text-align: center;
    }
    .right_menu {
      font-size: 0.37333rem;
      font-family: PingFang SC;
      color: #fff;
      flex: 1;
      text-align: right;
    }
  }
  .content {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      right: -0.3rem;
      top: 5rem;
      width: 3.52rem;
      height: 5.2rem;
      background: rgba(115, 28, 23, 0.9);
      filter: blur(2.4rem);
      z-index: 1;
    }
    .list {
      padding: .2rem .4rem;
      position: relative;
      z-index: 2;
      .list-item-bg {
        //background: linear-gradient(to left, #5d5e64, #030946);
        //border-radius: .21rem;
        //padding: 0.02rem;
        margin-bottom: .3rem;
      }
      .list-item {
        //background-color: #1e2223;
        background-size: 100% 100%;
        height: 4rem;
        //border-radius: .21rem;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 .6rem;
        position: relative;
        .title {
          display: flex;
          align-items: center;
          background: linear-gradient(180deg, rgba(250, 179, 131, 1) 0%, rgba(255, 227, 207, 1) 44.18%, rgba(221, 154, 108, 1) 100%);
          -webkit-background-clip: text !important;
          -webkit-text-fill-color: transparent;
          font-family: FZLanTingHei-B_GB18030;
          font-weight: bold;
          font-size: .64rem;
        }
        .desc {
          color: #fff;
          font-size: .37rem;
          margin-top: .2rem;
          height: 0.72rem;
          line-height: .72rem;
          border-radius:  0.267rem 0rem 0.267rem 0rem;
          background: linear-gradient(180deg, rgba(255, 190, 146, 1) 0%, rgba(221, 154, 108, 1) 100%);
          box-shadow: 0rem 0.053rem rgba(0, 0, 0, 0.25);
          padding: 0 .26rem;
          display: inline-block;
        }
        .bg-img {
          position: absolute;
          bottom: 0;
          right: 0.4rem;
          width: 3.37rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/list.vue